
import { StoreActionType as Type } from "../../types"; 
 
const initialState: any = {
  isLeftMenuOpen: true 
}; 

export const leftMenuReducer: any = (state: any = initialState, action: any) => {
   switch (action?.type) {
    case Type.SET_LEFTMENU_OPEN:
      return {
        ...state,
        isLeftMenuOpen: action?.payload?.isLeftMenuOpen,
      };

    default:
      return state;
  }
};
